function sanitizeCSVValue(val: string): string {
  if (/^[=+\-@\t\r]/.test(val)) {
    return "'" + val;
  }
  return val;
}

export function exportToCSV(data: Array<Record<string, unknown>>, filename: string, columns: { key: string; label: string }[]) {
  if (!data || data.length === 0) return;

  const header = columns.map(c => `"${sanitizeCSVValue(c.label).replace(/"/g, '""')}"`).join(',');
  const rows = data.map(row =>
    columns.map(c => {
      const val = row[c.key];
      if (val === null || val === undefined) return '""';
      const str = sanitizeCSVValue(String(val)).replace(/"/g, '""');
      return `"${str}"`;
    }).join(',')
  );

  const csv = '﻿' + [header, ...rows].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}_${new Date().toISOString().split('T')[0]}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
